// Copyright (c) 2017 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../actions-list';

const resetReport = () => getDefaultState();

const updateReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_REPORT]: resetReport,
        [actions.UPDATE_ADVANCED_CLAIM_SUMMARY_REPORT]: updateReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/report.js